module.exports = __webpack_public_path__ + "static/img/13.a7dda62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/13.png
// module id = ZwsO
// module chunks = 2